<script setup lang="ts">
import Cc3AuthLogo from '@/app/Cc3AuthLogo.vue'
import heroImg from '@/assets/images/simple-reg-hero.webp'
</script>

<template>
  <div class="simple-reg-hero" aria-hidden="true">
    <div class="simple-reg-hero__media">
      <img class="simple-reg-hero__img" :src="heroImg" alt="" />
    </div>
    <div class="simple-reg-hero__gradient" />
    <div class="simple-reg-hero__overlay" />
    <div class="simple-reg-hero__content">
      <Cc3AuthLogo />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.simple-reg-hero {
  display: none;

  @media screen and (min-width: 1024px) {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 50%;
    overflow: hidden;
    z-index: 0;
  }

  &__media {
    position: absolute;
    inset: 0;
    overflow: hidden;
  }

  &__img {
    position: absolute;
    left: 0;
    top: -10.61%;
    width: 100%;
    height: 127.36%;
    max-width: none;
    object-fit: cover;

    @media screen and (min-width: 1441px) {
      height: auto;
      object-position: top;
    }
  }

  &__gradient {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    pointer-events: none;
  }

  &__overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.16);
    pointer-events: none;
  }

  &__content {
    position: relative;
    z-index: 1;
    padding: 40px 48px 152px;

    :deep(svg path) {
      fill: #fff;
    }
  }
}
</style>
